export enum PublishRulesActionsEnum {
  PUBLISH_RULES_LOAD_DATA = 'PUBLISH_RULES_LOAD_DATA',
  PUBLISH_RULES_FETCH_TREE = 'PUBLISH_RULES_FETCH_TREE',
  PUBLISH_RULES_FETCH = 'PUBLISH_RULES_FETCH',
  PUBLISH_RULES_FETCH_HISTORY = 'PUBLISH_RULES_FETCH_HISTORY',
  PUBLISH_RULES_FETCH_HAVE_SAVED_SETTINGS_CATEGORIES = 'PUBLISH_RULES_FETCH_HAVE_SAVED_SETTINGS_CATEGORIES',
  PUBLISH_RULES_SET_TREE = 'PUBLISH_RULES_SET_TREE',
  PUBLISH_RULES_SET_ACTIVE_TREE_ITEM = 'PUBLISH_RULES_SET_ACTIVE_TREE_ITEM',
  PUBLISH_RULES_UPDATE_ACTIVE_TREE_ITEM = 'PUBLISH_RULES_UPDATE_ACTIVE_TREE_ITEM',
  PUBLISH_RULES_SET_NEXT_ACTIVE_TREE_ITEM = 'PUBLISH_RULES_SET_NEXT_ACTIVE_TREE_ITEM',
  PUBLISH_RULES_SET_FORM_REF = 'PUBLISH_RULES_SET_FORM_REF',
  PUBLISH_RULES_SET_FORM_DATA = 'PUBLISH_RULES_SET_FORM_DATA',
  PUBLISH_RULES_SET_HISTORY_CHANGES = 'PUBLISH_RULES_SET_HISTORY_CHANGES',
  PUBLISH_RULES_SET_IS_NEED_SAVE_ACCEPT = 'PUBLISH_RULES_SET_IS_NEED_SAVE_ACCEPT',
  PUBLISH_RULES_GET_KNM_STATUSES = 'PUBLISH_RULES_GET_KNM_STATUSES',
  PUBLISH_RULES_GET_ERP_STATUSES = 'PUBLISH_RULES_GET_ERP_STATUSES',
  PUBLISH_RULES_GET_PM_STATUSES = 'PUBLISH_RULES_GET_PM_STATUSES',
  PUBLISH_RULES_SET_HAS_CURRENT_SETTINGS = 'PUBLISH_RULES_SET_HAS_CURRENT_SETTINGS',
  PUBLISH_RULES_DROP_STATE_WITH_ACTIVE_TREE_ITEM_CHANGE = 'PUBLISH_RULES_DROP_STATE_WITH_ACTIVE_TREE_ITEM_CHANGE',
  PUBLISH_RULES_CREATE_OR_UPDATE = 'PUBLISH_RULES_CREATE_OR_UPDATE',
  PUBLISH_RULES_DELETE = 'PUBLISH_RULES_DELETE',
}
